import { useContext } from 'react';
import {
    ArticlesEtRemisesDesDossiersDeFormalitApi,
    DevisLignesFormalitApi,
    FacturationFormalitApi,
    AjustementDePrestationFormalitApi,
    FactureApi,
    DevisFormalitApi,
    FactureOpenSearchApi,
    DevisLignesAnnonceLgaleApi,
    PanierPaiementApi,
} from '@europrocurement/l2d-domain/openApi/ApiFacturation';
import { QuoteLineModel } from '@europrocurement/l2d-domain/reducers/facturation/Models/quoteLine';
import {
    FacturationReducerType,
    FactureOpenSearch,
    QuoteModel,
} from '@europrocurement/l2d-domain/reducers';
import { getDataThunkType } from '@europrocurement/l2d-redux-utils';
import L2DApiContext from '../L2DApiContext';

export const useFacturationService = () => {
    const context = useContext(L2DApiContext);
    if (!context) {
        throw new Error('useL2DApi must be used within a L2DApiProvider');
    }

    if (!context.facturation) {
        throw new Error('Facturation service is not registred in L2DApiProvider');
    }

    const { apis, slices, thunks, fetchItems, getItems, models, reducer } = context.facturation;

    return {
        devisFormaliteApi: apis.devisFormaliteApi as DevisFormalitApi,
        devisLignesFormaliteApi: apis.devisLignesFormaliteApi as DevisLignesFormalitApi,
        facturationFormaliteApi: apis.facturationFormaliteApi as FacturationFormalitApi,
        ajustementDePrestationFormalitApi:
            apis.ajustementDePrestationFormalitApi as AjustementDePrestationFormalitApi,
        articlesEtRemisesDesDossiersDeFormalitApi:
            apis.articlesEtRemisesDesDossiersDeFormalitApi as ArticlesEtRemisesDesDossiersDeFormalitApi,
        factureApi: apis.factureApi as FactureApi,
        facturesOpenSearchApi: apis.facturesOpenSearchApi as FactureOpenSearchApi,
        ligneDevisAnnonceLegaleApi: apis.ligneDevisAnnonceLegaleApi as DevisLignesAnnonceLgaleApi,
        panierPaiementApi: apis.panierPaiementApi as PanierPaiementApi,
        factureFormaliteSlice: slices.factureFormaliteSlice,
        devisSlice: slices.devisSlice,
        devisLigneSlice: slices.devisLigneSlice,
        factureOpenSearchSlice: slices.factureOpenSearchSlice,

        factureFormaliteDataSourcesThunks: thunks.factureFormaliteDataSourcesThunks,
        devisDataSourcesThunks: thunks.devisDataSourcesThunks,
        devisLigneDataSourcesThunks: thunks.devisLigneDataSourcesThunks,
        factureOpenSearchDataSourcesThunks: thunks.factureOpenSearchDataSourcesThunks,

        getFacturesFormalite: fetchItems.getFacturesFormalite,
        getDevis: fetchItems.getDevis,
        getDevisLignes: fetchItems.getDevisLignes,
        getFactureOpenSearch:
            fetchItems.getFactureOpenSearch as getDataThunkType<FactureOpenSearch>,

        selectFacturesFormalite: getItems.selectFacturesFormalite,
        selectDevis: getItems.selectDevis,
        selectDevisLignes: getItems.selectDevisLignes,
        selectFactureOpenSearch: getItems.selectFactureOpenSearch,

        quoteModel: models.quote as QuoteModel,
        quoteLineModel: models.quoteLine as QuoteLineModel,

        reducer: reducer as FacturationReducerType,
    };
};
